import { render, staticRenderFns } from "./ResultLottoset.vue?vue&type=template&id=60577595&scoped=true&"
import script from "./ResultLottoset.vue?vue&type=script&lang=js&"
export * from "./ResultLottoset.vue?vue&type=script&lang=js&"
import style0 from "./ResultLottoset.vue?vue&type=style&index=0&id=60577595&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60577595",
  null
  
)

export default component.exports